import { api } from 'app/config/apiConfig';
import { ArrivalStatisticsDetails, ArrivalStatisticsQueryParams, ArrivalStatisticsTotals } from '../model/types';

export const getArrivalStatisticsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getArrivalStatistics: build.query<ArrivalStatisticsDetails, ArrivalStatisticsQueryParams>({
      query: (args) => ({
        url: '/warehouses/statistics/arrival',
        params: args,
      }),
    }),
    getArrivalStatisticsTotal: build.query<ArrivalStatisticsTotals, ArrivalStatisticsQueryParams>({
      query: (args) => ({
        url: '/warehouses/statistics/arrival/total',
        params: args,
      }),
    }),
  }),
});

export const { useGetArrivalStatisticsQuery, useGetArrivalStatisticsTotalQuery } = getArrivalStatisticsApi;
